import { render, staticRenderFns } from "./BusinessUnitInfo.vue?vue&type=template&id=1c95fcf6&scoped=true&"
import script from "./BusinessUnitInfo.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95fcf6",
  null
  
)

export default component.exports